import axios from "axios";
import { BanResponse, SimpleUser, User, UsersResponse } from "@/api/types";

export const getSelf = () => axios.get<User>('users/self');
export const getStaff = () => axios.get<SimpleUser[]>('users/staff');
export const verifyEmail = (id: string, hash: string, signature: string, expires: string) =>
    axios.post('/users/email/verify', { id, hash }, { params: { signature, expires } });
export const sendVerify = (email: string) => axios.post('/users/email/send-verify', { email });
export const updateHWID = (hwid: string) => axios.post('/users/update/hwid', { hwid });
export const updateDiscord = (discord: number) => axios.post('/users/update/discord', { discord });
export const updateUsername = (username: string) => axios.post('/users/update/username', { username });
export const deleteAccount = (password: string) => axios.delete('/users/self', { data: { password } });
export const cancelSub = (password: string) => axios.delete(`/users/self/sub`, { data: { password } });
export const cancelSubAdvanced = (password: string) => axios.delete(`/users/self/sub/advanced`, { data: { password } });
export const updatePassword = (old_password: string, new_password: string) =>
    axios.post('/users/self/pw', { old_password, new_password });
export const getUsers = (query: string, limit: number, page: number) =>
    axios.get<UsersResponse>('/users', { params: { query, limit, page } });
export const setState = (state: boolean) => axios.post('/users/self/state', { state });
export const getBan = () => axios.get<BanResponse>('/users/self/ban');
export const banUser = (id: number, reason: string) => axios.post(`/users/${ id }/ban`, { reason });
export const unbanUser = (id: number) => axios.post(`/users/${ id }/unban`);
export const createDownload = (name: string, dev: boolean, timestamp: string, type: string) => axios.get<Blob>('/download', { params: { name, dev, timestamp, type }, responseType: 'blob' });
export const getUser = (id: string | number) => axios.get<User>(`/users/${ id }`);
export const revealUserEmail = (id: string | number) => axios.post<{ email: string }>(`/users/${ id }/reveal-email`);
export const revealUserIps = (id: string | number) => axios.post<{ ips: string[] }>(`/users/${ id }/reveal-ips`);
export const deleteUser = (id: number) => axios.delete(`/users/${ id }`);
export const updateUser = (id: number, user: Partial<User>) => axios.put(`/users/${ id }`, { ...user });
export const setUserPassword = (id: number, password: string) => axios.put(`/users/${ id }/pw`, { password });
export const deleteMessage = (id: number) => axios.delete(`messages/${ id }`);
export const setWithdrawn = (id: number) => axios.post(`/users/${ id }/withdraw`);

// 2FA API functions
export const get2FAStatus = () => axios.get('/2fa/status');
export const generate2FA = () => axios.post('/2fa/generate');
export const enable2FA = (code: string) => axios.post('/2fa/enable', { code });
export const disable2FA = (password: string, code?: string, recovery_code?: string) => 
    axios.post('/2fa/disable', { password, code, recovery_code });
export const viewRecoveryCodes = () => axios.get('/2fa/recovery-codes');
export const generateRecoveryCodes = () => 
    axios.post('/2fa/recovery-codes');
export const verify2FA = (code?: string, recovery_code?: string) => 
    axios.post('/2fa/verify', { code, recovery_code });
